    <div class="p-4">
        <h2 mat-dialog-title *ngIf="data.title" class="text-center mb-3">{{ data.title }}</h2>
        <div mat-dialog-content [innerHTML]="data.message" *ngIf="data.message" class="text-center mb-3">{{ data.message }}</div>
        <div mat-dialog-actions class="justify-content-center">
          <button mat-button class="fdx-c-button fdx-c-button--text fxg-margin-right" (click)="onCancelClick()" *ngIf="data.btnCancel">{{data.btnCancel}}</button>
          <button mat-button class="fdx-c-button fdx-c-button--primary fxg-margin-right" (click)="onConfirmClick()" cdkFocusInitial *ngIf="data.btnConfirm">{{data.btnConfirm}}</button>
        </div>
      </div>
  